import { render, staticRenderFns } from "./TwoFactorAuthSetup.vue?vue&type=template&id=0fd803c6&scoped=true&"
import script from "./TwoFactorAuthSetup.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthSetup.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuthSetup.vue?vue&type=style&index=0&id=0fd803c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd803c6",
  null
  
)

export default component.exports